import React, {Component} from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import accounting from 'accounting';
import { Button, Segment, Form, Dropdown, Popup , Icon, Checkbox} from 'semantic-ui-react';
import {applyCard} from '../../core/apiClient';
import {getConst} from '../../core/consts';
// import $ from 'jquery';
import { applySuccess, storeSimulateEmail, storeApplyFormInput } from '../../redux/actions';
import {getStaticText} from '../../core/lang';
import ReactPixel from 'react-facebook-pixel';
import ReactGA from 'react-ga';
import {nationality} from './nationality.js';

class ApplyForm extends Component {
  constructor() {
    super();
    this.state = {
      applyMessage: '',
      firstName: '',
      lastName: '',
      phoneNumber: '',
      emailId: '',
      salary: 5000,
      terms: false,
      selfEmployed:false,
      phoneNumberCode: '',
      openApplyResponsePopup: false,
      goodTimeToCall: '',
      nationality: '',
      errors: {
        firstName: '',
        lastName: '',
        phoneNumber: '',
        emailId: '',
        terms: '',
        salary: '',
        nationality: '',
        incomeType: '',
      },
      onFocus: '',
      openConfirmPopup: false,
    }
  }

  show = () => this.setState({ openApplyResponsePopup: true })
  close = () => this.setState({ openApplyResponsePopup: false })

  showConfirm = () => this.setState({ openConfirmPopup: true })
  handleConfirm = () => {
    this.setState({ openConfirmPopup: false });
    this.props.data.closeDirectApplyPopup();
  }
  handleCancel = () => this.setState({ openConfirmPopup: false })

  finalCardApply = (utmSource,utmMedium,utmCampaign) => {
    if(utmCampaign===null){
      utmCampaign = 'Nil';
    }
    else{
      utmCampaign = sessionStorage.getItem("utm_campaign")
    }

    if(utmMedium===null){
      utmMedium = 'Nil';
    }
    else{
      utmMedium = sessionStorage.getItem("utm_medium")
    }

    if(utmSource===null){
      utmSource = 'Nil';
    }
    else{
      utmSource = sessionStorage.getItem("utm_source")
    }
    let referrer = document.referrer;
    if(referrer===''|| _.isEmpty(referrer)){
      referrer = window.location.href;
    }
    
    console.log("Referrer URL apply form:", referrer);

    const validFirstName = this.handleFirstNameBlur(), validLastName = this.handleLastNameBlur(),
      validEmail = this.handleEmailIdBlur(), validPhone = this.handlePhoneNumberBlur(),
      validTerms = this.handleTermsValidate(), salary = this.handleSalaryBlur(),
      validNationality= this.handleNationalityBlur();

    if (validFirstName && validLastName && validEmail && validPhone && validTerms && salary && validNationality) {
        let email = this.state.emailId;
        let id =  _.isEmpty(this.props.data.applyCardObject)  ? this.props.match.params.id : this.props.data.applyCardObject.id ;
        id = parseInt(id, 10);
        if (_.isEmpty(email)) {
          email = this.props.simulateEmail;
        }

        let selfEmployedVal = 'false';
        if(this.state.selfEmployed===true){
          selfEmployedVal = this.state.selfEmployed.toString();
        }
        let goodTimeToCall = 'N/A'
        if(this.state.goodTimeToCall !== ''){
          goodTimeToCall = this.state.goodTimeToCall;
        }
        applyCard({
          'customer': {
            'first_name': this.state.firstName,
            'email': email,
            'last_name': this.state.lastName,
            'phone': `+971${this.state.phoneNumberCode}${this.state.phoneNumber}`,
            'salary': this.state.salary,
            'goodTimeToCall': goodTimeToCall,
            'selfEmployed' : selfEmployedVal,
            'nationality': this.state.nationality,
            "utm_tracking_details": {
              "utm_source": utmSource,
              "utm_medium": utmMedium,
              "utm_campaign": utmCampaign,
              "request_url": window.location.href,
              "http_referrer": referrer
              }
          },
          'productIds': [id]
        }
        ).then((response) => {

          this.props.storeSimulateEmail(email, false);
          this.props.storeApplyFormInput({
            firstName: this.state.firstName,
            lastName: this.state.lastName,
            phoneNumber: this.state.phoneNumber,
            phoneNumberCode: this.state.phoneNumberCode,
            emailId: email,
            salary: this.state.salary,
            selfEmployed : selfEmployedVal,
            nationality: this.state.nationality,
          },console.log("Props:", this.props.storeApplyFormInput));
          //this.props.submitted();
          ReactPixel.fbq('track', 'SubmitApplication');
          
          this.props.history.push(`/thank-you-page/${this.props.data.applyCardObject.name}/${id}`);
        }).catch((err) =>{
          this.props.storeSimulateEmail(email, false);
          this.props.storeApplyFormInput({
            firstName: this.state.firstName,
            lastName: this.state.lastName,
            phoneNumber: this.state.phoneNumber,
            phoneNumberCode: this.state.phoneNumberCode,
            emailId: email,
            salary: this.state.salary,
            selfEmployed: selfEmployedVal,
            nationality: this.state.nationality,
            //incomeType: this.state.incomeType,
          });
          //this.props.submitted();
          const {multiple_apply_error} = getStaticText(this.props.activeLanguage);
          this.props.applySuccess(`${multiple_apply_error}`, true);
          this.props.history.push(`/thank-you-page/${this.props.data.applyCardObject.name}/${id}`);
        })
    }

   const cardname = this.props.data.applyCardObject.name
    ReactGA.event({
            category: "Auto Loan",
            action: cardname+'-ApplyNow'
          }); 
  }

  suggest = () => {
    const validFirstName = this.handleFirstNameBlur(), validLastName = this.handleLastNameBlur(),
      validEmail = this.handleEmailIdBlur(), validPhone = this.handlePhoneNumberBlur(),
      validTerms = this.handleTermsValidate(), salary = this.handleSalaryBlur(), 
      validNationality = this.handleNationalityBlur();
    if (validFirstName && validLastName && validEmail && validPhone && validTerms && salary && validNationality) {
        let email = this.state.emailId;
        //let id =  _.isEmpty(this.props.data.applyCardObject)  ? this.props.match.params.id : this.props.data.applyCardObject.id ;
        if (_.isEmpty(email)) {
          email = this.props.simulateEmail;
        }
        //id = parseInt(id, 10);
        this.props.storeSimulateEmail(email, false);
        this.props.storeApplyFormInput({
          firstName: this.state.firstName,
          lastName: this.state.lastName,
          phoneNumber: this.state.phoneNumber,
          phoneNumberCode: this.state.phoneNumberCode,
          emailId: email,
          salary: this.state.salary,
          selfEmployed : this.state.selfEmployed
        });
        this.closeAllSuggestPopup();
        this.props.suggest(this.state.salary);
    }
  }


  handleTerms = (e, {checked}) => {
    this.setState({terms: checked})
  }

  handleSelfEmployed = (e, {checked}) => {
    console.log("Emp:",checked);
      this.setState({selfEmployed: checked})

   }

  handleTermsValidate = () => {
    let valid = false;
    const {accept_terms_message} = getStaticText(this.props.activeLanguage);
    if (!this.state.terms) {
      this.createError('terms', accept_terms_message);
    } else {
      this.createError('terms', '');
      valid = true;
    }
    return valid;
  }

  handleFirstNameBlur = () => {
    let valid = false;
    const {info_required_msg, only_alphanumeric_msg} = getStaticText(this.props.activeLanguage);
    const {alphaNumSpaceRegex} = getConst(this.props.activeLanguage);
    if (!alphaNumSpaceRegex.test(this.state.firstName)) {
      this.createError('firstName', only_alphanumeric_msg)
    } else if (_.isEmpty(this.state.firstName)) {
      this.createError('firstName', info_required_msg);
    } else {
      this.createError('firstName', '');
      valid = true;
    }
    this.onFocusField('')
    return valid;
  }

  handleLastNameBlur = () => {
    let valid = false;
    const {info_required_msg, only_alphanumeric_msg} = getStaticText(this.props.activeLanguage);
    const {alphaNumSpaceRegex} = getConst(this.props.activeLanguage);
    if (!alphaNumSpaceRegex.test(this.state.lastName)) {
      this.createError('lastName', only_alphanumeric_msg)
    } else if (_.isEmpty(this.state.lastName)) {
      this.createError('lastName', info_required_msg);
    } else {
      this.createError('lastName', '');
      valid = true;
    }
    this.onFocusField('')
    return valid;
  }

  handleEmailIdBlur = () => {
    let email = this.state.emailId;
    let valid = false;
    const {email_id_required_msg, email_id_valid_msg} = getStaticText(this.props.activeLanguage);
    const {emailRegex} = getConst(this.props.activeLanguage);
    if (_.isEmpty(email)) {
      this.createError('emailId', email_id_required_msg);
    } else if (!emailRegex.test(email)) {
      this.createError('emailId', email_id_valid_msg);
    } else {
      this.createError('emailId', '');
      valid = true;
    }
    this.onFocusField('')
    return valid;
  }

  handlePhoneNumberBlur = () => {
    let valid = false;
    const {phone_number_valid_msg} = getStaticText(this.props.activeLanguage);
    if (_.isEmpty(this.state.phoneNumber) || this.state.phoneNumber.length !== 7 || this.state.phoneNumber.includes(' ')
        || _.isEmpty(this.state.phoneNumberCode)|| this.state.phoneNumberCode.length !== 3) {
      this.createError('phoneNumber', phone_number_valid_msg);
    } else {
      this.createError('phoneNumber', '');
      valid = true;
    }
    this.onFocusField('')
    return valid;
  }

  handleNationalityBlur = () => {
    let valid = false;
    const {nationality_valid_msg} = getStaticText(this.props.activeLanguage);
    if (_.isEmpty(this.state.nationality)) {
      this.createError('nationality', nationality_valid_msg);
    } else {
      this.createError('nationality', '');
      valid = true;
    }
    this.onFocusField('')
    return valid;
  }

  handleSalaryBlur = () => {
    let valid = false;
    const {please_input_salary,please_input_min_salary} = getStaticText(this.props.activeLanguage);
    if (this.state.salary < 1 || this.state.salary === undefined) {
      this.createError('salary', please_input_salary);
    }else if(this.state.salary < 0){
      this.createError('salary', please_input_min_salary);
    } else {
      this.createError('salary', '');
      valid = true
    }
    return valid;
  }

  createError = (field, error) => {
    const errors = _.assign(this.state.errors, {[field]: error})
    this.setState({
      errors
    })
  }

  handleInputChange = (e, {value, name}) => {
    const {telephone} = getConst(this.props.activeLanguage);
    if(name === 'emailId'){
      value = value.trim();
    }
    if(name === 'firstName' || name === 'lastName'){
      value = value.toUpperCase();
    }
    if (name === 'phoneNumber') {
      if (telephone.test(value)) {
        this.setState({
          [name]: value
        })
      }
    } else {
      this.setState({
        [name]: value
      })
    }
  }

  handlePhoneNumberCode = (e, {value}) => {
    this.setState({phoneNumberCode: value})
  }

  closeAllSuggestPopup = () => {
    this.setState({
      terms: false,
      goodTimeToCall: '',
      errors: {
        firstName: '',
        lastName: '',
        phoneNumber: '',
        emailId: '',
        terms: '',
        salary:'',
        nationality:'',
        incomeType:'',
      }
    });
    this.close();
    this.props.data.closeDirectApplyPopup();
  }

  closeAllApplyPopup = () => {
    const {applying_auto_loan_with_us} = getStaticText(this.props.activeLanguage);
    this.props.applySuccess(`${applying_auto_loan_with_us} <strong> ${this.props.data.applyCardObject.bankName} - ${this.props.data.applyCardObject.name}</strong>`, true);
    this.props.history.push(`/thank-you-page/${this.props.data.applyCardObject.name}/${this.props.data.applyCardObject.id}`);
    this.setState({
      terms: false,
      goodTimeToCall: '',
      errors: {
        firstName: '',
        lastName: '',
        phoneNumber: '',
        emailId: '',
        terms: '',
        salary:'',
      }
    });
    this.close();
    this.props.closeDirectApplyPopup();
  }

  handleTimeToCall = (e, {value}) => {
    this.setState({goodTimeToCall: value});
  }

  handleNationality = (e, {value}) => {
    this.setState({nationality: value});
    this.createError('nationality', '');
  }

  handleMonthlySalaryChange = (value) => (this.setState({salary:value}));

  componentDidMount(){
    if(this.props.applyInputForm.salary ==='') {
      this.setState({
        salary: 0,
      });
    }
    if(this.props.applyInputForm){
      this.setState({
        firstName: this.props.applyInputForm.firstName,
        lastName: this.props.applyInputForm.lastName,
        phoneNumber: this.props.applyInputForm.phoneNumber,
        phoneNumberCode: this.props.applyInputForm.phoneNumberCode,
        emailId: this.props.applyInputForm.emailId,
        salary:this.props.applyInputForm.salary,
      });
    }
    if(this.props.simulateEmail){
    this.setState({emailId: this.props.simulateEmail});
    }
  }

  componentWillReceiveProps(nextProps) {
    if(this.props.applyInputForm !== nextProps.applyInputForm){
      this.setState({
        errors: {
          firstName: '',
          lastName: '',
          phoneNumber: '',
          emailId: '',
          terms: '',
          salary: '',
        },
        terms: false,
      });
      this.setState({
        firstName: nextProps.applyInputForm.firstName,
        lastName: nextProps.applyInputForm.lastName,
        phoneNumber: nextProps.applyInputForm.phoneNumber,
        phoneNumberCode: this.props.applyInputForm.phoneNumberCode,
        emailId: nextProps.applyInputForm.emailId,
        salary: nextProps.applyInputForm.salary,
      });
    }
  }

  fixBody() {
    const anotherModal = document.getElementsByClassName('ui page modals').length;
    if (anotherModal > 0) document.body.classList.add('scrolling', 'dimmable', 'dimmed');
  }

  handleSalaryInputChange = (e, {value, max}) => {
    const formatedValue = accounting.unformat(value)
    let validValue = formatedValue;
    if (max < formatedValue) {
      validValue = max;
    }
    this.setState({ salary: _.toNumber(validValue) })
  }

  onFocusField = (name) => {
    this.setState({onFocus: name})
  }

  digitValidate = (e) => {
    const re = /^[0-9.]*$/;
    if (!re.test(e.key)) {
      e.preventDefault();
    }
  }



  render() {

    var hiddenFields = document.querySelectorAll("input[type=hidden], input[type=text]");

    for (var i=0; i<hiddenFields.length; i++) {
      var utmParam = sessionStorage.getItem(hiddenFields[i].name);
          var utmCampaign = sessionStorage.getItem("utm_campaign");
          
          var utmMedium = sessionStorage.getItem("utm_medium");
          
          var  utmSource = sessionStorage.getItem("utm_source");
          //document.getElementById("utm-source-hidden-field").value = 'hi';

          if (utmParam) {
            document.getElementsByName("utm_campaign")[0].value = utmCampaign;
            document.getElementsByName("utm_medium")[0].value = utmMedium;
            document.getElementsByName("utm_source")[0].value = utmSource;
          }
          
          // console.log("what is this:",document.getElementById("utm-source-hidden-field").value = 'hi')
          // if (utmParam) {document.getElementById("utm-source-hidden-field").value = sessionStorage.getItem(hiddenFields[i].name);
          
          // }
          
    }

    
    let referrer = document.referrer;
    if(referrer===''){
      referrer = window.location.href;
    }
    
    const lang = getStaticText(this.props.activeLanguage);
    const {phoneNumberCode} = getConst(this.props.activeLanguage);
    return (
      <Segment>
         <p>{this.props.data.applyCardObject.contract ? lang.apply_online_description : lang.apply_online_description_1}</p>
        <Form className='custom-form ' id='apply-form'>
          <div className='form-control'>
            <span className={!_.isEmpty(this.state.firstName) || this.state.onFocus === 'firstName'?'label-animate active': 'label-animate'}>{lang.first_name} <span className='asterik'>*</span></span>
            <Form.Input
              value={this.state.firstName}
              onBlur={this.handleFirstNameBlur}
              name='firstName'
              onChange={this.handleInputChange}
              maxLength={30}
              id='apply-first'
              onFocus={(value) => this.onFocusField('firstName')}
            />
            <span className='input-error'>{this.state.errors.firstName}</span>
          </div>
          <div className='form-control'>
            <span className={!_.isEmpty(this.state.lastName) || this.state.onFocus === 'lastName'?'label-animate active':'label-animate'}>{lang.last_name} <span className='asterik'>*</span></span>
            <Form.Input
              value={this.state.lastName}
              onBlur={this.handleLastNameBlur}
              name='lastName'
              onChange={this.handleInputChange}
              maxLength={30}
              id='apply-last'
              onFocus={(value) => this.onFocusField('lastName')}
            />
            <span className='input-error'>{this.state.errors.lastName}</span>
          </div>
          <div className='form-control'>
            <span className={!_.isEmpty(this.state.emailId) || this.state.onFocus === 'emailId'?'label-animate active':'label-animate'}>{lang.email_id} <span className='asterik'>*</span></span>
            <Form.Input
              value={this.state.emailId}
              onBlur={this.handleEmailIdBlur}
              name='emailId'
              onChange={this.handleInputChange}
              maxLength={50}
              id='apply-email'
              onFocus={(value) => this.onFocusField('emailId')}
            />
            <span className='input-error'>{this.state.errors.emailId}</span>
          </div>
          <div className='form-control'>
            <span className={!_.isEmpty(this.state.phoneNumber) || this.state.onFocus === 'phoneNumber'?'label-animate active top-0':'label-animate top-0'}><span className='asterik'></span></span>
            <div className='phone-number-wrap'>
              <span>+971</span>
              <div className='label'>
              <Dropdown
                  value={this.state.phoneNumberCode}
                  selection
                  options={phoneNumberCode}
                  onChange={this.handlePhoneNumberCode}
                  search={false}
                />
              </div>
              <div className='field-phone-number'>
              <Form.Input
                  value={this.state.phoneNumber}
                  placeholder={`${lang.ex}: 8989899`}
                  onBlur={this.handlePhoneNumberBlur}
                  name='phoneNumber'
                  type='tel'
                  pattern='[0-9]{7}'
                  onChange={this.handleInputChange}
                  maxLength={7}
                  id='apply-phone'
                  onFocus={(value) => this.onFocusField('phoneNumber')}
                  onKeyPress={this.digitValidate}
                />
              </div>
            </div>
            {
              (this.state.phoneNumberCode==='' || this.state.phoneNumber==='' ||  _.size(this.state.phoneNumber)!==7)?
              <span className='input-error'>{this.state.errors.phoneNumber}</span>:''
            }
          </div>
          {/* <div className='form-control direct-apply--opt choose-time'>
            <p>{lang.good_time_to_call}</p>
            <Dropdown
              value={this.state.goodTimeToCall}
              selection
              options={goodTimeToCall}
              onChange={this.handleTimeToCall}
              search={false}
              id='goodtime'
              placeholder={lang.choose_time}
            />
          </div> */}
          <div className='form-control direct-apply--opt-nat choose-time'>
          <p>Nationality*</p>
            <Dropdown
              value={this.state.nationality}
              selection
              options={nationality}
              onChange={this.handleNationality}
              search={true}
              id='goodtime'
              placeholder={lang.select}
              // placeholder={lang.choose_nationality}
            >
            {/*nationality.map((item, idx) => (
              <Dropdown.item>item.value</Dropdown.item>
            ))*/}
            </Dropdown>
            <span className='input-error'>{this.state.errors.nationality}</span>
          </div>
          <div className='form-control direct-apply--salary good-call'>
          
            <span>{lang.monthly_salary} <span className='asterik'>*</span></span>
            <Form.Input
              onChange={this.handleSalaryInputChange}
              //value='abd'
              pattern='[0-9]*'
              value={this.state.salary>0? `${lang.aed} ${accounting.formatMoney(this.state.salary, '', 0)}`:''}
              //placeholder='8989899'
              max={200000}
              type='tel'
              onBlur={this.handleSalaryBlur}
              className='has-price-format margin-btm-0'
              onKeyPress={this.digitValidate}
              placeholder={lang.aed_5000}
            />
            <span className='input-error'>{this.state.errors.salary}</span>
          </div>

          <input type="hidden" id="utm-source-hidden-field" name="utm_source" value={utmSource===null?'Nil':utmSource} />
          <input type="hidden" id="utm-medium-hidden-field" name="utm_medium" value={utmMedium===null?'Nil':utmMedium} />
          <input type="hidden" id="utm-campaign-hidden-field" name="utm_campaign" value={utmCampaign===null?'Nil':utmCampaign}/>

          {/* <div className='form-control direct-apply--opt-nat choose-time'>
          <p>Income Type*</p>
            <Dropdown
              value={this.state.selfEmployed}
              selection
              options={incomeType}
              onChange={this.handleSelfEmployed}
              search={false}
              id='goodtime'  
            >
           
            </Dropdown>
            <span className='input-error'>{this.state.errors.incomeType}</span>
          </div> */}
          <div className='self-em form-control '>
            <Checkbox onClick={this.handleSelfEmployed} checked={this.state.selfEmployed} required label='' className='display-inline-block left unasterik'></Checkbox>
            <label className='width-90 display-inline-block self_emp_label'>{lang.self_em}</label>
          </div>
          <div className='form-control padding-top-0 direct-apply--terms'>
            <Form.Checkbox checked={this.state.terms} onClick={this.handleTerms} required label='' className='des-apply unasterik'></Form.Checkbox> 
            {
              this.props.data.applyCardObject.bankName === 'Citibank'?
              <label className="citi-label">{lang.citi_disclaimer}
              <p>Credit Bureau Consent, Welcome Offer & General Terms & Conditions
              <Popup
                trigger={<Icon name="info" />}
                content={lang.credit_bureau }
                size='tiny'
                position='left center'
                basic
                wide='very'
                on='click'
              /></p> 
              {/* <p>Authorization to request Account Statement from Central Bank
              <Popup
                trigger={<Icon name="info" />}
                content={lang.authorization}
                size='tiny'
                wide
                basic
                on='click'
              /></p> */}
               </label>:
               this.props.data.applyCardObject.bankName === 'deem'?
               <label className="citi-label">{lang.deem_disclaimer}
               <Popup
                   trigger={<span style={{color:'#03b4f7'}}>read more</span>}
                   content={lang.deem_popup}
                   size='tiny'
                   wide='very'
                   position='left center'
                   basic
                   on='click'
               />
               </label>:
               this.props.data.applyCardObject.name === 'Elite'?
               <label className="citi-label">{lang.rak_elite_disclaimer}</label>:
               <label className='width-90 display-inline-block margin-left-10'>
                {lang.apply_terms} I confirm that I have read and agree to Soulwallet Portal LLC’s <a href='/terms-and-conditions' target="_blank">Terms</a> and <a href='/privacy-policy' target="_blank"> Privacy Policy</a>.
                { this.props.data.applyCardObject.name === 'Citigold'?
                 <p>{lang.citi_gold_new_disclaimer}
                 <Popup
                     trigger={<span style={{color:'#03b4f7'}}>read more</span>}
                     content={lang.citi_gold_popup}
                     size='tiny'
                     wide='very'
                     position='left center'
                     basic
                     on='click'
                 />
                 </p>
                 :
                 this.props.data.applyCardObject.bankName === 'Citi'?
                 <p>{lang.citi_new_disclaimer}
                 <Popup
                     trigger={<span style={{color:'#03b4f7'}}>read more</span>}
                     content={lang.citi_popup}
                     size='tiny'
                     wide='very'
                     position='left center'
                     basic
                     on='click'
                 />
                 </p>:''
              }
              </label>
              }
              
            {
              this.state.terms===false?
              <span className='input-error'>{this.state.errors.terms}</span>:''
            }
          </div>
        </Form>
        {
          this.props.applynowButton ?
          <div className='quick-view-content-button'>
            {
              this.props.data.applyCardObject.contract?
              <Button className='btn btn-orange right' onClick={()=>this.finalCardApply(utmSource,utmMedium,utmCampaign)} id='submit-application'>{lang.applynow}</Button>
              :
              <Button className='btn btn-blue orange' onClick={this.suggest}>{lang.suggest}</Button>
              // <span className='applyBtn' title={this.props.data.applyCardObject.contract?'':lang.non_contract_alert_less}>
              //   <Button className='btn btn-blue right '>{lang.apply}</Button>
              // </span>
            }
          </div>
          :
          <div>
            {
              this.props.applynowButton === null ?
              null
              :
              this.props.data.applyCardObject.contract?
              <Button className='show-for-desktop quick-view-apply-btn btn btn-blue' id='submit-application' onClick={()=>this.finalCardApply(utmSource,utmMedium,utmCampaign)}>{lang.apply}</Button>
              :
              <Button className='show-for-desktop quick-view-apply-btn btn btn-blue' onClick={this.suggest}>{lang.suggest}</Button>
              // <span className='applyBtn' title={this.props.data.applyCardObject.contract?'':lang.non_contract_alert_less}>
              //   <Button className='show-for-desktop quick-view-apply-btn btn btn-blue '>{lang.apply}</Button>
              // </span>
            }
          </div>
        }

      </Segment>
    );
  }
}


const mapStateToProps = (state, ownProps) => ({
  applyInputForm : state.applyInputForm,
  activeLanguage: state.activeLanguage,
  simulateEmail: state.simulateEmail.email,
});

const mapDispatchToProps = {
  applySuccess,
  storeSimulateEmail,
  storeApplyFormInput,
};

const ApplyCardContainer = withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(ApplyForm));

export default ApplyCardContainer;



// WEBPACK FOOTER //
// ./src/components/applyForm/applyForm.js